          const hideATC = () => {            
              const swiperSlides = document.querySelectorAll('.swiper-slide');
              swiperSlides.forEach((slide) => {
                  if (slide.querySelector('.bsscommerce-ltsp-message')) {
                      const form = slide.querySelector('form[action="/cart/add"]');
                      if (form) {
                          form.remove();
                      }
                  }
              });
          }
          
          hideATC();
          
          let count = 0;
          
          window.addEventListener('scroll', function() {
              if (count <= 4) {
                  const twoThirdsHeight = (1 / 3) * (document.documentElement.scrollHeight - window.innerHeight);
                  
                  if (window.scrollY >= twoThirdsHeight) {
                      hideATC();
                      count++;
                  }
              }
          });

          const productPriceElements = document.querySelectorAll('[data-pf-type="ProductPrice2"]');
      
          productPriceElements.forEach(productPriceElement => {
              const ltspElement = productPriceElement.querySelector('.bsscommerce-ltsp-message');
      
              if (ltspElement) {
                  const priceElement = productPriceElement.querySelector('[data-product-type="price"]');
                  if (priceElement) {
                      priceElement.remove();
                  }
              }
          });